import { render, staticRenderFns } from "./RasterMapExtendedLegend.vue?vue&type=template&id=df4f5382&scoped=true"
import script from "./RasterMapExtendedLegend.vue?vue&type=script&lang=js"
export * from "./RasterMapExtendedLegend.vue?vue&type=script&lang=js"
import style0 from "./RasterMapExtendedLegend.vue?vue&type=style&index=0&id=df4f5382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df4f5382",
  null
  
)

export default component.exports